export const VERSION = '4.82.0'; // x-release-please-version
//# sourceMappingURL=version.mjs.map